import axios from "axios"

let baseURL
let rootURL = "https://eody.co.in"

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    rootURL = "https://eody.co.in"
} else {
    rootURL = "https://eody.co.in"
}
baseURL = rootURL + "/api"
const apiURL = rootURL + "/api"
const satApiURL = rootURL + "/api/sat"

function getToken() {
    let user = JSON.parse(window.localStorage.getItem("user"))
    if (user) {
        return user.token
    } else {
        return ""
    }
}

let axios_http = axios.create({
    baseURL,
})
let SAT_HTTP = axios.create({
    baseURL: satApiURL,
})

// axios_http.interceptors.request.use(
//     (config) => {
//         const token = getToken()
//         console.log("config headers", config, config.headers)
//         const auth = token ? `Bearer ${token}` : ""
//         if (!config.headers["Authorization"]) {
//             config.headers["Authorization"] = auth
//         }
//         return config
//     },
//     (error) => Promise.reject(error)
// )

axios_http.interceptors.response.use(function(response) {
    return response
}, errorInterceptor)
SAT_HTTP.interceptors.response.use(function(response) {
    return response
}, errorInterceptor)

function errorInterceptor(error) {
    console.log("the error is", error, error.response, error.response.data)
    if (error.response && error.response.status === 401) {
        window.localStorage.removeItem("user")
        window.localStorage.removeItem("isLogged")
        return (window.location.href = "/login")
    }
    return error.response
}
const getAuthorizationHeader = () => {
    let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getToken(),
    }
    return headers
}
console.log("SAT API URL", satApiURL, "sat http", SAT_HTTP)

const HTTP = axios_http
export { SAT_HTTP, HTTP, baseURL, rootURL, apiURL, satApiURL, getAuthorizationHeader }
